import React, { useMemo } from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { DynamicMediaItem, Paragraph, Profile } from '@uncinc/react-drupal-core';
import {
  Button,
  Container,
  WysiwygField,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import type { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import { SCREEN_LG } from '../../../../config/constants';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeChild: React.FC<ThemeProps> = ({ entity }) => {
  const { width } = useWindowDimensions();
  const isScreenLarge = useMemo(() => width >= SCREEN_LG, [width]);

  const theme = entity.toJS();
  const classes = c('TaxonomyTheme');

  return (
    <div className={classes}>
      <Container>
        <div className="content-section">
          <div className="row">
            <div className="col-12 col-lg-7">
              <div className="content-section mt-0">
                <h1>{theme.name[0].value}</h1>
                <WysiwygField
                  html={theme.description[0].value || ''}
                />
                {theme.field_link[0] && (
                  <Button href={theme.field_link[0].alias || theme.field_link[0].uri} className="mt-5">{theme.field_link[0].title}</Button>
                )}
              </div>
              {!isScreenLarge && (
                <div className="content-section">
                  <DynamicMediaItem media={theme.field_media_item[0]} imageAspectRatio="2_1" />
                </div>
              )}
              <div className="content-section">
                {theme.field_paragraphs && (
                  <>
                    {theme.field_paragraphs.map((paragraph) => {
                      const paragraphId = paragraph.target_id;
                      const language = paragraph.entity.langcode[0].value;
                      return (
                        <Paragraph
                          key={`paragraph:${paragraphId}:${language}`}
                          id={paragraphId}
                          entity={Immutable.fromJS(paragraph.entity)}
                        />
                      );
                    })}
                  </>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-xl-4 offset-xl-1">
              {isScreenLarge && (
                <div className="sidebar-section">
                  <DynamicMediaItem media={theme.field_media_item[0]} imageAspectRatio="2_1" />
                </div>
              )}
              <div className="sidebar-section">
                {theme.field_contact_person?.[0] && (
                  <Profile
                    id={theme.field_contact_person[0].target_id}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TaxonomyThemeChild;
